import { define, html } from "hybrids";

export interface VBroadcastContainer extends HTMLElement {
  overflow: boolean;
  stickToBottom: boolean;
  grow: boolean;

  scrollToBottom: (smooth?: boolean) => void;
}

function scrollToBottomIfNeeded(host: VBroadcastContainer) {
  requestAnimationFrame(() => {
    const el = host.lastElementChild?.previousElementSibling;
    if (el) {
      const result = el.getBoundingClientRect();
      if (result.top < window.innerHeight) {
        host.scrollToBottom();
      }
    }
  });
}

export default define<VBroadcastContainer>({
  tag: "v-broadcast-container",
  overflow: false,
  stickToBottom: {
    value: false,
    observe: (host, value) => {
      if (value) host.scrollToBottom(false);
    },
  },
  grow: false,
  scrollToBottom:
    (host) =>
    (smooth = true) => {
      Promise.resolve().then(() => {
        const { scrollHeight, clientHeight } = host;
        const el =
          scrollHeight > clientHeight ? host : document.scrollingElement;

        el?.scrollTo({
          top: el.scrollHeight,
          behavior: smooth ? "smooth" : "auto",
        });
      });
    },
  render: ({ stickToBottom }) => html`
    <slot onslotchange="${stickToBottom && scrollToBottomIfNeeded}"></slot>
  `.css`
    :host {
      display: block;
      padding: var(--v-broadcast-layout-spacing, 0px);
      border-top: 1px solid rgba(128, 129, 145, 0.1);
      -webkit-overflow-scrolling: touch;
      flex: 0 1 auto;
    }

    :host([overflow]) { 
      overflow: auto;
      scrollbar-width: none; 
    }
    :host([overflow])::-webkit-scrollbar { 
      display: none; 
    }
    
    :host([grow]) { flex-grow: 1 }

    :host(:first-child) { border-top: none; }
  `,
});
